import { render, staticRenderFns } from "./deliveryEmptyState.vue?vue&type=template&id=2da9cc99"
import script from "./deliveryEmptyState.vue?vue&type=script&lang=js"
export * from "./deliveryEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da9cc99')) {
      api.createRecord('2da9cc99', component.options)
    } else {
      api.reload('2da9cc99', component.options)
    }
    module.hot.accept("./deliveryEmptyState.vue?vue&type=template&id=2da9cc99", function () {
      api.rerender('2da9cc99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/marketplace/deliveryEmptyState.vue"
export default component.exports